// Formatters compartilhados (números, moeda, percentuais, datas).
// Replicam fmt/fmtMoney/fmtPct do protótipo.

export const fmt = (n: number | null | undefined): string => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return Number(n).toLocaleString("pt-BR");
};

export const fmtMoney = (n: number | null | undefined): string => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    const v = Number(n);
    if (Math.abs(v) >= 1000) return "$" + (v / 1000).toFixed(1) + "k";
    return "$" + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtMoneyFull = (n: number | null | undefined): string => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return "$" + Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtPct = (v: number | null | undefined, digits = 1): string => {
    if (v === null || v === undefined || Number.isNaN(v)) return "—";
    return Number(v).toFixed(digits) + "%";
};

// Format ISO (YYYY-MM-DD) → BR (DD/MM/YYYY)
export const fmtBR = (iso: string | null | undefined): string => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
};

export const toISO = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
};

export const daysBetween = (a: string | null | undefined, b: string | null | undefined): number => {
    if (!a || !b) return 0;
    return Math.round((new Date(b).getTime() - new Date(a).getTime()) / 86400000) + 1;
};

// Helpers pra Comparable<T> — extraem current/delta com fallback defensivo
// (backend ainda tá devolvendo previous=0, então delta pode vir errado).
type Comparable = { current?: number; previous?: number; delta?: { pct?: number; dir?: string } | null } | null | undefined | number;

export const cur = (c: Comparable, def = 0): number => {
    if (c && typeof c === "object" && "current" in c) return Number(c.current ?? def);
    if (typeof c === "number") return c;
    return def;
};

export const deltaPct = (c: Comparable): number | null => {
    if (c && typeof c === "object" && c.delta?.pct != null) return c.delta.pct;
    return null;
};

export const deltaDir = (c: Comparable): "up" | "down" | "flat" => {
    if (c && typeof c === "object" && c.delta?.dir) return (c.delta.dir as "up" | "down" | "flat");
    return "flat";
};

export const fmtDelta = (c: Comparable): string | null => {
    if (!c || typeof c !== "object") return null;
    const d = c.delta;
    if (!d || d.dir === "flat") return null;
    const sign = d.dir === "up" ? "+" : "";
    return sign + (d.pct ?? 0).toFixed(1) + "%";
};
